import { useMemo } from "react";
import { MileageCorrectionData } from "../types";

export const useMileageCorrection = (specificObject: any) => {
  const mileageData = useMemo(() => {
    const correctionDate = specificObject?.correctionDate;
    const newMileage = specificObject?.mileageCorrection;
    const comment = specificObject?.comment;

    const currentMileageField = specificObject?.metadata?.find(
      (item: any) => item.field?.id === 10
    );
    const lastReportedMileage = currentMileageField?.value
      ? parseFloat(currentMileageField.value)
      : 0;

    return {
      correctionDate,
      newMileage,
      comment,
      lastReportedMileage,
      systemCalculatedMileage: lastReportedMileage
    };
  }, [specificObject]);

  const formatDate = (dateString?: string) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("en-US", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric"
    });
  };

  const formatMileage = (mileage?: number) => {
    return mileage ? `${mileage.toLocaleString().replace(".", ",")} km` : "-";
  };

  const truncateText = (text?: string, maxLength: number = 50) => {
    if (!text) return "-";
    return text.length > maxLength
      ? `${text.substring(0, maxLength)}...`
      : text;
  };

  return {
    ...mileageData,
    formatDate,
    formatMileage,
    truncateText
  };
};
